var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dashboard loading-content-container" }, [
    !_vm.preferencesLoaded
      ? _c(
          "div",
          { staticClass: "loading-overlay d-flex justify-content-center pt-5" },
          [_c("csp-loading-indicator")],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.preferencesLoaded,
            expression: "preferencesLoaded",
          },
        ],
      },
      [
        _c(
          "b-row",
          { staticClass: "mb-3" },
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _c(
                "div",
                { staticClass: "float-right" },
                [
                  _vm.preferencesLoaded
                    ? _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            switch: true,
                            "unchecked-value": 0,
                            value: 1,
                          },
                          on: { change: _vm.saveDashboardPreferences },
                          model: {
                            value: _vm.displayDamageRecordsOfFirm,
                            callback: function ($$v) {
                              _vm.displayDamageRecordsOfFirm = $$v
                            },
                            expression: "displayDamageRecordsOfFirm",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                    Nur eigene Akten\n                "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasPermission(
          "Csp_Dashboard_Widget_DamageRecordApprovedOverview"
        ) || _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordEditStatus")
          ? _c(
              "b-row",
              [
                _vm.hasPermission(
                  "Csp_Dashboard_Widget_DamageRecordApprovedOverview"
                )
                  ? _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("csp-table", {
                          attrs: {
                            "default-page-options": _vm.pageOptions,
                            "default-per-page": _vm.perPage,
                            "disable-pagination": true,
                            icon: "inticon-autoclaim_files",
                            "items-ajax-url":
                              _vm.dashboardRepository.getDamageRecordApprovedOverviewUrl(),
                            "legacy-data-structure": true,
                            "table-headline":
                              "Angenommene / eigenbearbeitete Schadenakten",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordEditStatus")
                  ? _c(
                      "b-col",
                      { attrs: { cols: "6" } },
                      [
                        _c("csp-table", {
                          attrs: {
                            "default-page-options": _vm.pageOptions,
                            "default-per-page": _vm.perPage,
                            "disable-pagination": true,
                            icon: "inticon-autoclaim_user",
                            "items-ajax-url":
                              _vm.dashboardRepository.getDamageRecordEditStatusUrl(),
                            "legacy-data-structure": true,
                            "table-headline": "Schadenaktenbearbeitung aktuell",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordOverdueInquiry")
          ? _c(
              "b-row",
              { staticClass: "mt-4" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("csp-table", {
                      attrs: {
                        "default-page-options": _vm.pageOptions,
                        "default-per-page": _vm.perPage,
                        icon: "inticon-autoclaim_phone-landline",
                        "item-detail-id-label": "damageRecordId",
                        "item-detail-url":
                          _vm.dashboardRepository.getDamageRecordItemDetailUrl(),
                        "items-ajax-url":
                          _vm.dashboardRepository.getDamageRecordOverdueInquiryUrl(),
                        "legacy-data-structure": true,
                        "table-headline": "Unerledigte Rückfragen",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordStatus") ||
        _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordNoteInquiry")
          ? _c(
              "b-row",
              { staticClass: "mt-4" },
              [
                _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordStatus")
                  ? _c(
                      "b-col",
                      { attrs: { cols: "5" } },
                      [
                        _c("csp-table", {
                          attrs: {
                            "default-page-options": _vm.pageOptions,
                            "default-per-page": _vm.perPage,
                            "disable-pagination": true,
                            icon: "inticon-autoclaim_files",
                            "items-ajax-url":
                              _vm.dashboardRepository.getDamageRecordStatusUrl(),
                            "legacy-data-structure": true,
                            "table-headline": "Schadenaktenstatus",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasPermission(
                  "Csp_Dashboard_Widget_DamageRecordNoteInquiry"
                )
                  ? _c(
                      "b-col",
                      { attrs: { cols: "7" } },
                      [
                        _c("csp-table", {
                          attrs: {
                            "default-page-options": _vm.pageOptions,
                            "default-per-page": _vm.perPage,
                            icon: "inticon-autoclaim_phone-landline",
                            "item-detail-id-label": "damageRecordId",
                            "item-detail-url":
                              _vm.dashboardRepository.getDamageRecordItemDetailUrl(),
                            "items-ajax-url":
                              _vm.dashboardRepository.getDamageRecordNoteInquiryUrl(),
                            "legacy-data-structure": true,
                            "table-headline": "Offene Rückfragen",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordNoteReminder")
          ? _c(
              "b-row",
              { staticClass: "mt-4" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("csp-table", {
                      attrs: {
                        "default-page-options": _vm.pageOptions,
                        "default-per-page": _vm.perPage,
                        icon: "inticon-autoclaim_calendar",
                        "item-detail-id-label": "damageRecordId",
                        "item-detail-url":
                          _vm.dashboardRepository.getDamageRecordItemDetailUrl(),
                        "items-ajax-url":
                          _vm.dashboardRepository.getDamageRecordNoteReminderUrl(),
                        "legacy-data-structure": true,
                        "table-headline": "Wiedervorlagen/Fristen",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordInactivity")
          ? _c(
              "b-row",
              { staticClass: "mt-4" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("csp-table", {
                      attrs: {
                        "default-page-options": _vm.pageOptions,
                        "default-per-page": _vm.perPage,
                        icon: "inticon-autoclaim_attention",
                        "item-detail-id-label": "vehicleDamageRecordId",
                        "item-detail-url":
                          _vm.dashboardRepository.getDamageRecordItemDetailUrl(),
                        "items-ajax-url":
                          _vm.dashboardRepository.getDamageRecordInactivityUrl(),
                        "legacy-data-structure": true,
                        "table-headline": "Inaktive Schadenakten",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordInactiveFirms") &&
        _vm.isReseller
          ? _c(
              "b-row",
              { staticClass: "mt-4" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("csp-table", {
                      attrs: {
                        "default-page-options": _vm.pageOptions,
                        "default-per-page": _vm.perPage,
                        icon: "inticon-autoclaim_assign",
                        "item-detail-id-label": "firmId",
                        "item-detail-url":
                          _vm.dashboardRepository.getFirmItemDetailUrl(),
                        "items-ajax-url":
                          _vm.dashboardRepository.getDamageRecordInactiveFirmsUrl(),
                        "legacy-data-structure": true,
                        "table-headline": "Inaktive Firmen",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordNewFiles")
          ? _c(
              "b-row",
              { staticClass: "mt-4" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("csp-table", {
                      attrs: {
                        "default-page-options": _vm.pageOptions,
                        "default-per-page": _vm.perPage,
                        icon: "inticon-autoclaim_document_accident",
                        "item-detail-id-label": "vehicleDamageRecordId",
                        "item-detail-url":
                          _vm.dashboardRepository.getDamageRecordItemDetailUrl(),
                        "items-ajax-url":
                          _vm.dashboardRepository.getDamageRecordNewFilesUrl(),
                        "legacy-data-structure": true,
                        "table-headline": "Neue Dokumente",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordInactiveFirms") &&
        !_vm.isReseller
          ? _c(
              "b-row",
              { staticClass: "mt-4" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("csp-table", {
                      attrs: {
                        "default-page-options": _vm.pageOptions,
                        "default-per-page": _vm.perPage,
                        icon: "inticon-autoclaim_assign",
                        "item-detail-id-label": "firmId",
                        "item-detail-url":
                          _vm.dashboardRepository.getFirmItemDetailUrl(),
                        "items-ajax-url":
                          _vm.dashboardRepository.getDamageRecordInactiveFirmsUrl(),
                        "legacy-data-structure": true,
                        "table-headline": "Inaktive Firmen",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.hasPermission("Csp_Dashboard_Widget_DamageRecordOverdueReminder")
          ? _c(
              "b-row",
              { staticClass: "mt-4" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("csp-table", {
                      attrs: {
                        "default-page-options": _vm.pageOptions,
                        "default-per-page": _vm.perPage,
                        icon: "inticon-autoclaim_calendar",
                        "item-detail-id-label": "damageRecordId",
                        "item-detail-url":
                          _vm.dashboardRepository.getDamageRecordItemDetailUrl(),
                        "items-ajax-url":
                          _vm.dashboardRepository.getDamageRecordOverdueReminderUrl(),
                        "legacy-data-structure": true,
                        "table-headline": "Überfällige Wiedervorlagen/Fristen",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }